<template>
	<div class="chat-settings-option" :title="hint">
		<div class="chat-settings-title">{{ title }}</div>
		<div @change="onUpdate" :name="name" type="radio">
			<label v-for="v in values"
				><input type="radio" :name="name" :value="v.value" v-bind="{checked: value == v.value}"
					> {{ v.description }}</label>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		hint: {
			type: String,
			default: '',
		},
		title: String,
		name: String,
		values: Array,
		value: String,
	},

	methods: {
		onUpdate(e){
			this.$emit('input', e.target.value);
		},
	},
}
</script>

<style lang="less" scoped>
.chat-settings-option {
	> * {
		width: 100%;
	}

	> .chat-settings-title {
		margin-bottom: 5px;
	}
}

label > input {
	vertical-align: middle;
}
</style>
